const matches = {
  firestorePath: 'matches',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'matches',
  statePropName: 'data',
  namespaced: true, // automatically added
  serverChange: {
    convertTimestamps: {
      startDate: '%convertTimestamp%',
    },
  },
  state: {
  },
  getters: {
    array: state => Object.values(state.data),
    selectQuery: state => {
      // Map to new objects — never mutate store docs from a getter (was freezing Archive Admin).
      const data = Object.values(state.data).map((d) => {
        let label = ''
        label = d.competitionName ? label + d.competitionName + ' | ' : ''
        label = d.competition ? label + d.competition + ' | ' : ''
        label = label + d.team1Name + ' vs ' + d.team2Name

        let selectedLabel = ''
        selectedLabel = d.competition ? selectedLabel + d.competition + ' | ' : ''
        selectedLabel = selectedLabel + d.team1Name + ' vs ' + d.team2Name

        return {
          ...d,
          label,
          selectedLabel,
        }
      })
      return data.sort((a, b) => {
        if (a.startDate > b.startDate) {
          return -1
        }
        if (a.startDate < b.startDate) {
          return 1
        }
        if (!a.startDate) {
          return -1
        }
        return 0
      })
    },
    obj: state => state.data,
    byId: (state) => (id) => {
      return state.data[id]
    },
  },
  mutations: {
  },
  actions: {
  },
}

export default matches